import { BidApiModel } from 'app/api/types';
import { Field } from 'app/containers/Builder/props';

type TransportType = {
	[name: string]: BidApiModel.CommonMeta;
};

//helpers
export const mapTransportTypes = (transportTypes?: TransportType): Array<Field.Choice<string>> => {
	return Object.values(transportTypes || {}).map(
		(value): Field.Choice<string> => ({
			label: value.name,
			value: value.id,
		}),
	);
};

export const mapTrailerTypes = (trailerTypes?: TransportType): Array<Field.Choice<string>> => {
	return Object.values(trailerTypes || {}).map(
		(value): Field.Choice<string> => ({
			label: value.name,
			value: value.id,
		}),
	);
};

export const mapTransportBrands = (transportBrands?: BidApiModel.CommonMeta[]): Array<Field.Choice<string>> => {
	return (transportBrands || []).map(
		(brand): Field.Choice<string> => ({
			label: brand.name,
			value: brand.id,
		}),
	);
};

export const findTransportTypeByName = (
	transportTypes: TransportType, // need with trailers
	name: string,
): BidApiModel.CommonMeta | undefined => {
	return Object.values(transportTypes).find((type) => type.name === name);
};
